export const environment = {
  production: false,
  development: true,
  apiUrl: 'https://dev.hubix.ro/api',
  gtmId: '',
  stripe: {
    publicKey: 'pk_test_51QCy6OR9fpbpcKbDrL2wmgO6uBTXlQhIL8UbZyLtPz9q5PhfYdZwPJ0SQi7xMi8rgM2UpaWsMvrxeKsLsjjn3jAG00Hp3YoNuA'
  }
};
